import { createStyles } from '@material-ui/core';
import { fade, makeStyles, Theme } from '@material-ui/core/styles';

import { BIG_MARGIN, colorsPalette, MIDDLE_MARGIN, TINY_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      marginBottom: BIG_MARGIN,
      [theme.breakpoints.up('lg')]: {
        marginBottom: 0,
        '&:not(:last-child)': {
          marginBottom: BIG_MARGIN,
        },
      },
    },
    title: {
      display: 'block',
      fontSize: 20,
      fontWeight: 700,
      borderBottom: `2px solid ${fade(colorsPalette.violet, 0.3)}`,
      padding: `${TINY_MARGIN}px 12px`,
      marginBottom: MIDDLE_MARGIN,
    },
  }),
);

export default useStyles;
